import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from '@app/core/services/environment.service';
import { PagedData } from '@app/modules/lookup/models/paged-data.model';
import { Observable } from 'rxjs';
import { api_routes } from '@app/consts';
import { Import, ImportFileUpload, ImportLog, ImportStatus } from '../models/imports.model';

const headers = new HttpHeaders({
  'Content-Type':  'application/json',
});

@Injectable({
  providedIn: 'root'
})
export class ImportsService {

  constructor(private http: HttpClient, private envService: EnvironmentService) { }

  getImports(take?: number, skip?: number, sort?: string, filter?: string, asOf?: string): Observable<PagedData<Import>> {
    let params = new HttpParams();
    sort ? params = params.append('sort', sort) : null;
    filter ? params = params.append('filter', filter) : null;
    asOf ? params = params.append('asOf', asOf) : null;
    skip ? params = params.append('skip', skip) : null;
    take ? params = params.append('take', take) : null;

    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.IMPORTS}`, {
      headers: headers,
      params: params
    });
  }

  getImport(id: string): Observable<Import> {
    return this.http.get<Import>(`${this.envService.env.apiUrl}${api_routes.IMPORTS}/${id}`, {
      headers: headers
    });
  }

  createImport(importData: Import): Observable<Import> {
    return this.http.post<Import>(`${this.envService.env.apiUrl}${api_routes.IMPORTS}`, importData, {
      headers: headers
    });
  }

  updateImport(id: string, importData: Import): Observable<Import> {
    return this.http.put<Import>(`${this.envService.env.apiUrl}${api_routes.IMPORTS}/${id}`, importData, {
      headers: headers
    });
  }

  deleteImport(id: string): Observable<void> {
    return this.http.delete<void>(`${this.envService.env.apiUrl}${api_routes.IMPORTS}/${id}`, {
      headers: headers
    });
  }

  copyImport(id: string): Observable<{ id: string }> {
    return this.http.post<Import>(`${this.envService.env.apiUrl}${api_routes.IMPORTS}/${id}/${api_routes.COPY}`, {}, {
      headers: headers
    });
  }

  uploadImportFile(importId: string, file: File, name: string): Observable<any> {
    const formData: FormData = new FormData();

    formData.append('File', file);
    formData.append('Name', name ? name : '');

    return this.http.post<any>(
     `${this.envService.env.apiUrl}${api_routes.IMPORTS}/${importId}/${api_routes.UPLOAD}`,
      formData,
      {
        headers: {},
        reportProgress: true,
        observe: 'events'
      }
    );
  }

  // uploadImportFile(importId: string, importFileUpload: ImportFileUpload): Observable<any> {
  //   const formData = new FormData();
  //   formData.append('file', importFileUpload.file);
  //   formData.append('name', importFileUpload.name);

  //   return this.http.post<any>(`${this.envService.env.apiUrl}${api_routes.IMPORTS}/${importId}/${api_routes.UPLOAD}`, formData, {
  //     headers: headers
  //   });
  // }

  validateImportFile(importId: string): Observable<any> {
    return this.http.post<any>(`${this.envService.env.apiUrl}${api_routes.IMPORTS}/${importId}/${api_routes.VALIDATE}`, {
      headers: headers
    });
  }

  triggerImport(importId: string): Observable<any> {
    return this.http.post<any>(`${this.envService.env.apiUrl}${api_routes.IMPORTS}/${importId}/${api_routes.IMPORT}`, {
      headers: headers
    });
  }

  getImportStatuses(): Observable<ImportStatus[]> {
    return this.http.get<ImportStatus[]>(`${this.envService.env.apiUrl}${api_routes.IMPORTS}/${api_routes.STATUSES}`, {
      headers: headers
    });
  }

  getColumnMappingTypes(): Observable<PagedData<{id: string, name: string}>> {
    return this.http.get<PagedData<{id: string, name: string}>>(`${this.envService.env.apiUrl}${api_routes.IMPORTS}/${api_routes.COLUMN_MAPPING_TYPES}`, {
      headers: headers
    });
  }

  downloadImportFile(importId: string): Observable<any> {
    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.IMPORTS}/${importId}/${api_routes.DOWNLOAD}`, {
      headers: headers,
      observe: 'response',
      responseType: 'blob' as 'json'
    });
  }

  getImportLogs(take?: number, skip?: number, sort?: string, filter?: string, asOf?: string): Observable<PagedData<ImportLog>> {
    let params = new HttpParams();
    sort ? params = params.append('sort', sort) : null;
    filter ? params = params.append('filter', filter) : null;
    asOf ? params = params.append('asOf', asOf) : null;
    skip ? params = params.append('skip', skip) : null;
    take ? params = params.append('take', take) : null;

    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.IMPORTS}/${api_routes.LOGS}`, {
      headers: headers,
      params: params
    });
  }

  async getAllImportLogs(sort?: string, filter?: string): Promise<PagedData<ImportLog>> {
      let take = 100;
      let skip = 0;
      let allData = {
        skip: null,
        take: null,
        totalPages: null,
        total: null,
        data: []
      }
  
      while (allData.total === null || skip < allData.total) {
          const res = await this.getImportLogs(take, skip, sort, filter).toPromise();
  
          if (res && res.data && res.data.length > 0) {
            allData.data = allData.data.concat(res.data);
              skip += take;
              allData.total = res.total;
          } else {
              break;
          }
      }
  
      return allData;
    }

}